import { Plan, Product } from "../appData/productData"
import ProductDiscountHandler from "./productDiscountHandler"
import PromoPricingInfo from "./promoPricingInfo"

export type FlowType = "monthlyToYearly" | "premiumToUltimate"

class PostPurchaseHandler {
  constructor(
    private product: Product,
    private plan: Plan,
    private ultimatePlan: Plan
  ) {}

  get flowType(): FlowType | null {
    if (!this.plan.isUltimate && this.product.duration === "yearly") {
      return "premiumToUltimate"
    }

    if (this.product.duration === "monthly") {
      return "monthlyToYearly"
    }

    return null
  }

  get promoProduct() {
    if (this.flowType === "monthlyToYearly") {
      return this.plan.yearlyProduct
    }

    if (this.flowType === "premiumToUltimate") {
      return this.ultimatePlan.yearlyProduct
    }

    return null
  }

  get shouldShowFlow() {
    if (this.flowType === "monthlyToYearly") {
      return this.shouldShowMonthlyToYearly
    }

    if (this.flowType === "premiumToUltimate") {
      return this.shouldShowPremiumToUltimate
    }

    return false
  }

  private get shouldShowMonthlyToYearly() {
    if (this.product.duration !== "monthly") {
      return false
    }

    const yearlyProduct = this.plan.yearlyProduct
    const discountHandler = new ProductDiscountHandler(yearlyProduct)

    return discountHandler.hasPromoPriceDiscount
  }

  private get shouldShowPremiumToUltimate() {
    if (this.plan.isUltimate) {
      return false
    }

    const yearlyProduct = this.ultimatePlan.yearlyProduct
    const discountHandler = new ProductDiscountHandler(yearlyProduct)

    return discountHandler.hasPromoPriceDiscount
  }

  get upsellType() {
    if (this.flowType === "monthlyToYearly") {
      if (this.plan.isUltimate) {
        return "ultimateMonthlyToUltimateYearly"
      }

      return "premiumMonthlyToUltimateYearly"
    }

    if (this.flowType === "premiumToUltimate") {
      return "premiumYearlyToUltimateYearly"
    }

    return null
  }

  get pricingInfo() {
    if (this.promoProduct == null) {
      return null
    }

    if (this.flowType == "premiumToUltimate") {
      return PromoPricingInfo.fromYearlyProducts(
        this.promoProduct,
        this.ultimatePlan.yearlyProduct,
        true
      )
    }

    return PromoPricingInfo.fromYearlyAndMonthlyProduct(
      this.promoProduct,
      this.plan.monthlyProduct,
      true,
      true
    )
  }
}

export default PostPurchaseHandler
